import { createRouter, createWebHistory } from "vue-router";
import { useAuthStore } from '@/store/auth'

const SiteHome = () => import(/* webpackChunkName: "Home" */"@/views/pages/SiteHome.vue")
const UserLogin = () => import(/* webpackChunkName: "Login" */"@/views/pages/UserLogin")
// const UserSignUp = () => import(/* webpackChunkName: "SignUp" */"@/views/pages/UserSignUp")
// const DemoRecording = () => import(/* webpackChunkName: "DemoRecording" */"@/views/pages/DemoRecording")
// const StreamTranslator = () => import(/* webpackChunkName: "StreamTranslator" */"@/views/pages/StreamTranslator")
const Terms = () => import(/* webpackChunkName: "Terms" */"@/views/pages/Terms")
const RenderSubmit = () => import(/* webpackChunkName: "RenderSubmit" */"@/views/pages/RenderSubmitPage.vue")
const RenderHistory = () => import(/* webpackChunkName: "RenderHistory" */"@/views/pages/RenderHistoryPage.vue")
// const EditRenderResult = () => import(/* webpackChunkName: "EditRenderResult" */"@/views/pages/EditRenderResultPage.vue")
// const FabricRenderSubmit = () => import(/* webpackChunkName: "FabricRenderSubmit" */"@/views/pages/FabricRenderSubmitPage.vue")
// Swatch-book colour management (mask + HSV/tint editor). Replaces the old
// HSV-calibrate ColorWrapPage — colours are adjusted by editing the swatch
// image itself now, matching the management console's workflow.
const ColorWrapManagement = () => import(/* webpackChunkName: "ColorWrapManagement" */"@/views/pages/SwatchBookColorPage.vue")
const WrapTrainingDatasetPage = () => import(/* webpackChunkName: "WrapTrainingDatasetPage" */"@/views/pages/WrapTrainingDatasetPage.vue")
// const UnderConstructionPage = () => import(/* webpackChunkName: "UnderConstructionPage" */ "@/views/pages/UnderConstructionPage.vue")
const AccountManagementPage = () => import(/* webpackChunkName: "AccountManagementPage" */ "@/views/pages/AccountManagementPage.vue")
const ActivationCodeManagementPage = () => import(/* webpackChunkName: "ActivationCodeManagementPage" */ "@/views/pages/ActivationCodeManagementPage.vue")
const HelpPage = () => import(/* webpackChunkName: "HelpPage" */"@/views/pages/HelpPage.vue")
const SubAccountManagementPage = () => import(/* webpackChunkName: "SubAccountManagementPage" */"@/views/pages/SubAccountManagementPage.vue")
const PaymentSuccessPage = () => import(/* webpackChunkName: "PaymentSuccessPage" */"@/views/pages/PaymentSuccessPage.vue")
const PurchaseCancelPage = () => import(/* webpackChunkName: "PurchaseCancelPage" */"@/views/pages/PurchaseCancelPage.vue")
const DeleteAccountPage = () => import(/* webpackChunkName: "DeleteAccountPage" */"@/views/pages/DeleteAccountPage.vue")
const CustomerLeadsPage = () => import(/* webpackChunkName: "CustomerLeadsPage" */"@/views/pages/CustomerLeadsPage.vue")
const StoreManagementPage = () => import(/* webpackChunkName: "StoreManagementPage" */"@/views/pages/StoreManagementPage.vue")
const BrandDashboardPage = () => import(/* webpackChunkName: "BrandDashboardPage" */"@/views/pages/BrandDashboardPage.vue")
const ImpersonationLanding = () => import(/* webpackChunkName: "ImpersonationLanding" */"@/views/pages/ImpersonationLanding.vue")

const routes = [
    { path: "/", component: SiteHome },
    { path: "/login", component: UserLogin },
    { path: "/impersonated", component: ImpersonationLanding },
    { path: "/account", component: AccountManagementPage },
    { path: "/activation-code", component: ActivationCodeManagementPage },
    { path: "/sub-account", component: SubAccountManagementPage, meta: { requiresPrivileged: true } },
    { path: "/purchase/success", component: PaymentSuccessPage },
    { path: "/purchase/cancel", component: PurchaseCancelPage },

    // { path: "/signup", component: UserSignUp },
    // { path: "/demo", component: DemoRecording},
    // { path: "/stream", component: StreamTranslator},
    { path: "/terms", component: Terms },
    { path: "/delete", component: DeleteAccountPage },
    { path: "/wrap-colors", component: ColorWrapManagement, meta: { feature: 'colors' } },
    { path: "/render", component: RenderSubmit },
    { path: "/history", component: RenderHistory },
    { path: "/training", component: WrapTrainingDatasetPage, meta: { feature: 'training' } },
    { path: "/help", component: HelpPage },
    { path: "/brand/dashboard", component: BrandDashboardPage, meta: { feature: 'dashboard' } },
    { path: "/brand/leads", component: CustomerLeadsPage, meta: { feature: 'leads' } },
    { path: "/brand/stores", component: StoreManagementPage, meta: { feature: 'store' } },
    // { path: "/fabric", component: FabricRenderSubmit },
    // { path: "/edit-render", component:EditRenderResult}
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

router.beforeEach((to, from, next) => {
    const authStore = useAuthStore()

    // Routes gated on a specific brand feature (per-account access, replacing
    // the old all-or-nothing type=1 "advanced account" gate).
    const featureRoute = to.matched.find(record => record.meta.feature)
    if (featureRoute) {
        if (!authStore.isLoggedIn) {
            next({ path: '/login', query: { redirect: to.fullPath } })
        } else if (!authStore.hasFeature(featureRoute.meta.feature)) {
            next({ path: '/' })
        } else {
            next()
        }
        return
    }

    // Routes that require admin or distributor role
    if (to.matched.some(record => record.meta.requiresPrivileged)) {
        const isPrivileged = authStore.isAdminAccount || authStore.isDistributorAccount
        if (!authStore.isLoggedIn) {
            next({ path: '/login', query: { redirect: to.fullPath } })
        } else if (!isPrivileged) {
            next({ path: '/' })
        } else {
            next()
        }
        return
    }

    // Routes that require authentication
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!authStore.isLoggedIn || !authStore.isTokenValid) {
            authStore.logout()
            next({ path: '/login', query: { redirect: to.fullPath } })
        } else {
            next()
        }
    } else {
        next()
    }
})

export default router;
